export default "__VITE_ASSET__CDvNN6fm__"